import { render, staticRenderFns } from "./DialogPageFaces.vue?vue&type=template&id=aa03d0ee&scoped=true&"
import script from "./DialogPageFaces.vue?vue&type=script&lang=js&"
export * from "./DialogPageFaces.vue?vue&type=script&lang=js&"
import style0 from "./DialogPageFaces.vue?vue&type=style&index=0&id=aa03d0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa03d0ee",
  null
  
)

export default component.exports